"use strict";
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  background-color: var(--color-neutral-50, #f7faff);\n  border-color: var(--color-neutral-500, #8492ae);\n  border-radius: var(--border-radius-small, 6px);\n  border-style: solid;\n  border-width: var(--border-width-small, 2px);\n  color: var(--color-neutral-700, #425678);\n  display: flex;\n  padding: var(--spacing-regular, 16px);\n  >\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    FlowStatusBanner: function() {
        return FlowStatusBanner_default;
    },
    SomePanel: function() {
        return SomePanel_default;
    }
});
module.exports = __toCommonJS(src_exports);
// src/components/SomePanel/SomePanel.jsx
var import_prop_types = __toESM(require("prop-types"));
// src/components/SomePanel/styled.js
var import_styled_components = __toESM(require("styled-components"));
var PanelRoot = import_styled_components.default.div(_templateObject());
// src/components/SomePanel/SomePanel.jsx
var import_jsx_runtime = require("react/jsx-runtime");
var SomePanelProps = {
    content: import_prop_types.default.string
};
var SomePanel = function(param) {
    var content = param.content;
    if (content) return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(PanelRoot, {
        children: [
            "Some Panel: ",
            content
        ]
    });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PanelRoot, {
        children: "Some Panel: Default Content"
    });
};
SomePanel.displayName = "SomePanel";
SomePanel.propTypes = SomePanelProps;
var SomePanel_default = SomePanel;
// src/components/FlowStatusBanner/FlowStatusBanner.jsx
var import_prop_types2 = __toESM(require("prop-types"));
var import_component_library = require("@appcues/component-library");
var import_jsx_runtime = require("react/jsx-runtime");
var FlowStatusBannerProps = {
    isPublished: import_prop_types2.default.boolean,
    isPublishedAndDirty: import_prop_types2.default.boolean,
    showBanner: import_prop_types2.default.boolean
};
var FlowStatusBanner = function(param) {
    var isPublished = param.isPublished, isPublishedAndDirty = param.isPublishedAndDirty, showBanner = param.showBanner;
    if (!isPublished || !showBanner) {
        return null;
    }
    return isPublishedAndDirty ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_component_library.CBanner, {
        type: "warning",
        marginBottom: 16,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_component_library.CBanner.Content, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("strong", {
                    children: "Heads up!"
                }),
                " You've made changes, but users won't see them until you hit ",
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("i", {
                    children: "Push Changes"
                }),
                ". Or you can discard changes via the dropdown."
            ]
        })
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_component_library.CBanner, {
        type: "positive",
        marginBottom: 16,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_component_library.CBanner.Content, {
            children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("strong", {
                    children: "This flow is live!"
                }),
                " You can make changes and publish them when you are ready."
            ]
        })
    });
};
FlowStatusBanner.propTypes = FlowStatusBannerProps;
FlowStatusBanner.displayName = "FlowStatusBanner";
var FlowStatusBanner_default = FlowStatusBanner;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    FlowStatusBanner: FlowStatusBanner,
    SomePanel: SomePanel
});
//# sourceMappingURL=index.js.map